import { Base } from "../core/base.model";

export class EtapaProyectoBean extends Base {

    id_etapa: number;
    nombre: string;
	descripcion: string;
	id_proyecto_etapa: number;
	nombreProyecto: string;
	fechaInicio: string;
	fechaFin: string;
	id_lider_etapa: number;
	nombreCompletoLider: string;

}